import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Button from '../../../common/Button'
import { caseActions } from '../../../../store/case'
import { caseQuickUpdate } from '../../../../lib/fetchApi'
import { notificationActions } from '../../../../store/notifications'

import classes from './ReinstateiItem.module.css'

const ReinstateiItem = ({data, type, folder}) => {
    const dispatch = useDispatch()
    const [isLoading, setIsloading] = useState(false)
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const reinstateHandler = async () => {
        setIsloading(true)
       
        const reqBody = {
            type: type,
            type_id: data.id,
            fields: {
                active: 1
            }    
        }
        let dispatchBody = {
            folder: folder,
            item: {
                itemId: data.id,
                fields: [
                    {
                        field: 'active',
                        value: 1
                    }
                ]  
            }
        }

      
        dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))


        const update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } 

        setIsloading(false)
    }

    return <div className={classes.reinstate_container}>
        <div className={classes.reinstate_container_inner}>
            <Button click={reinstateHandler} isLoading={isLoading} title={'Restore'} btnStyle={'reinstate'}>
                <i className='ti ti-restore'></i>
            </Button>
        </div>    
    </div>
}

export default ReinstateiItem